var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("scroll-bar " + _vm.mode)},[_c('div',{ref:"track",staticClass:"scroll-track",style:(_vm.trackStyle)},[_c('div',{ref:"scrollThumb",staticClass:"scroll-thumb",style:(_vm.style)},[_vm._t("thumb-content")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }